module.exports = __webpack_public_path__ + "files/SOS Strategy Clarification.8e00a6b2.pptx";